import { isFunction, isNativeFunction } from "@posthog/core";
import { logger } from "./logger.mjs";
import { isAngularZonePresent } from "./type-utils.mjs";
const cachedImplementations = {};
function getNativeImplementation(name, assignableWindow) {
    const cached = cachedImplementations[name];
    if (cached) return cached;
    let impl = assignableWindow[name];
    if (isNativeFunction(impl) && !isAngularZonePresent()) return cachedImplementations[name] = impl.bind(assignableWindow);
    const document = assignableWindow.document;
    if (document && isFunction(document.createElement)) try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        logger.warn(`Could not create sandbox iframe for ${name} check, bailing to assignableWindow.${name}: `, e);
    }
    if (!impl || !isFunction(impl)) return impl;
    return cachedImplementations[name] = impl.bind(assignableWindow);
}
function getNativeMutationObserverImplementation(assignableWindow) {
    return getNativeImplementation('MutationObserver', assignableWindow);
}
export { getNativeImplementation, getNativeMutationObserverImplementation };
